import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { Button, CloseButton, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import moment from 'moment';
import { Drawer } from 'rsuite';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import { PageHeader, Pagination, SelectSearch } from '../../components';
import CheckableDataTable from '../../components/CheckableDataTable/CheckableDataTable';
import VoucherActivationModal from '../../components/Modals/VoucherActivationModal';
import VoucherExtensionModal from '../../components/Modals/VoucherExtensionModal';
import VoucherCSVUploadModal from '../../components/Modals/VoucherCSVUploadModal';
import DataTable from '../../components/DataTable/DataTable';
import ViewMerchantViewModal from '../../components/Modals/MerchantCodesModal';
import TransferOwnershipModal from '../../components/Modals/TransferOwnershipModal';
import PrintOptionsModal from '../../components/Modals/PrintOptionsModal';
import PrinterSettingsModal from '../../components/Modals/PrinterSettingsModal';
import { PRINTER_TASKS } from '../../utils/printerSettings';
import ChangeMerchantGroupModal from '../../components/Modals/ChangeMerchantGroupModal';
import ChangeVoucherThemeModal from '../../components/Modals/ChangeVoucherThemeModal';
import VoucherRenotifyModal from '../../components/Modals/VoucherRenotifyModal';
import CorporateInvoiceIdEditor from '../../components/CorporateInvoiceIdEditor/CorporateInvoiceIdEditor';

import useComponentState from './../../utils/useComponentState';
import {
  getVouchersByStatus,
  searchVouchers,
  activateVoucher,
  getTransactions,
  getCarrierPdf,
  updateVoucherDetails,
  getTransferredData,
  updateMultipleVoucherStatus,
  getDeliverySms,
} from '../../api/Vouchers';
import { confirmVoucherPayment } from '../../api/Purchase';
import { useGetQueryParams } from '../../hooks/useGetQueryParams';
import { useSetQueryParams } from '../../hooks/useSetQueryParams';
import { APP_PARAMS } from '../../constants/appParams';
import { DATE_TIME_TYPES } from '../../constants/dataTimeTypes';
import {
  validateDetails,
  validateMessage,
  validateMobileNumber,
  validateReceiverName,
  validateSenderName,
} from '../../utils/validations';
import { formatDateTime, formatDateTimeSriLanka } from '../../utils/dataFormatter';
import {
  INITIAL_EDIT_STATUS,
  INITIAL_ACTIVATION_STATUS,
  INITIAL_MERCHANT_GROUP_STATUS,
  ALLOWED_STATUS_KEYS,
  DEFAULT_PAGE_SIZE,
  TABLE_HEADINGS,
  TAB_ITEMS,
} from './ViewVouchersConstants';
import {
  getAllowedStatuses,
  generateAndSavePdf,
  createCarrierPrintRequest,
  copyToClipboardWithFeedback,
  buildCheckBalanceUrl,
  truncateText,
  validateEditFieldValue,
  getEditFieldInitialValue,
  getEditStateKeyForField,
  isSearchingByReceiverNumber,
  dedupeLabels,
} from './ViewVouchersUtils';

import {
  faTimes,
  faEdit,
  faCopy,
  faInfoCircle,
  faSpinner,
  faCheck,
  faPen,
} from '@fortawesome/free-solid-svg-icons';

import styles from './ViewVouchers.module.scss';
const ViewVouchers = (props) => {
  const queryParams = useGetQueryParams([
    APP_PARAMS.PAGE,
    APP_PARAMS.FILTER,
    APP_PARAMS.SEARCH_ID,
    APP_PARAMS.SEARCH_KEY,
    APP_PARAMS.SELECTED,
  ]);
  const setQueryParam = useSetQueryParams();
  const [state, setState] = useComponentState({
    tableHeading: TABLE_HEADINGS.voucher,
    transactionHeading: TABLE_HEADINGS.transaction,
    transferredHeading: TABLE_HEADINGS.transferred,
    loading: false,
    activationLoading: false,
    transactionLoading: false,
    merchantCodesLoading: false,
    detailsUpdateLoading: false,
    statusUpdateLoading: false,
    merchantGroupUpdateLoading: false,

    voucherData: [],
    transactionDetails: [],
    merchantCodesDetails: [],
    currentPage: queryParams.page - 1 || 0,
    totalPages: 0,
    pageSize: DEFAULT_PAGE_SIZE,

    searchKey: queryParams.searchKey || '',
    searchId: queryParams.searchId || 'id',
    statusKey: 'ALL',
    isClearable: false,
    label: 'Voucher ID',
    searchPlaceholder: 'Voucher ID',

    fetchError: '',
    transactionError: '',
    merchantCodesError: '',
    mobileError: '',
    activationError: '',
    notFoundMessage: '',

    isEditing: false,
    editingField: null,
    editSenderName: '',
    editReceiverName: '',
    editMessage: '',
    editReceiverMobile: '',
    receiverName: '',
    receiverMobile: '',
    validated: false,

    showVoucherDrawer: false,
    showActivationModal: false,
    showExtensionModal: false,
    showTransactions: false,
    showMerchantCodesModal: false,
    showUploadModal: false,
    showOwnerTransferModal: false,
    showRenotifyModal: false,
    showPrintOptionsModal: false,
    showPrinterSettingsModal: false,

    showMerchantGroupModal: false,
    selectedVoucherId: null,
    currentMerchantGroup: null,

    showVoucherThemeModal: false,
    currentVoucherTheme: null,
    voucherThemeUpdateLoading: false,

    isSelected: false,
    selectAll: false,
    checkedRows: [],
    labelsToPrint: [],

    voucherId: null,
    drawerData: null,
    selectedTransaction: null,
    selectedTransferred: null,
    selectedRedemptionId: null,
    voucherExpiryDate: null,
    activationSuccess: false,
    extensionSuccess: false,
    extensionDate: '',
    copiedField: null,
    deliveryEmail: '',
    scheduleDate: '',
    smsContent: '',
    isBoardPrinting: false,

    tabItems: TAB_ITEMS,
    transferredData: [],
  });
  const {
    tableHeading,
    voucherData,
    label,
    loading,
    totalPages,
    currentPage,
    pageSize,
    receiverName,
    receiverMobile,
    searchPlaceholder,
    searchId,
    showVoucherDrawer,
    drawerData,
    searchKey,
    tabItems,
    statusKey,
    fetchError,
    voucherId,
    activationLoading,
    mobileError,
    validated,
    showActivationModal,
    activationError,
    isEditing,
    editingField,
    editSenderName,
    editReceiverName,
    editMessage,
    editReceiverMobile,

    activationSuccess,
    isSelected,
    selectAll,
    checkedRows,
    showExtensionModal,
    voucherExpiryDate,
    showTransactions,
    showMerchantCodesModal,
    transactionDetails,
    transactionLoading,
    transactionError,
    selectedTransaction,
    selectedTransferred,
    transactionHeading,
    transferredHeading,
    selectedRedemptionId,
    showUploadModal,
    showOwnerTransferModal,
    labelsToPrint,
    showRenotifyModal,
    showPrintOptionsModal,
    showPrinterSettingsModal,
    copiedField,
    statusUpdateLoading,
    detailsUpdateLoading,
    transferredData,
    isBoardPrinting,
    smsContent,
  } = state;

  useEffect(() => {
    const loadInitialData = async () => {
      if (!searchKey && !queryParams.searchKey) {
        await getVoucherDetails(0);
        setQueryParam({
          [APP_PARAMS.PAGE]: queryParams.page || 1,
          [APP_PARAMS.FILTER]: statusKey,
        });
      } else if (queryParams.searchKey) {
        await searchVoucherById(0);
      }
    };

    loadInitialData();
    // queryParams.page is intentionally excluded - this effect always loads
    // page 0, and including it caused a second fetch on mount whenever the
    // page param below was written to the URL for the first time.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusKey, searchKey, queryParams.searchKey]);

  useEffect(() => {
    if (showVoucherDrawer && voucherId) {
      getDeliverySmsDetails(voucherId);
    }
  }, [showVoucherDrawer, voucherId]);

  const getDeliverySmsDetails = async (voucherID) => {
    setState({ smsContent: '' });
    try {
      const { smsContent } = await getDeliverySms(
        voucherID,
        props.auth.auth.token
      );
      setState({ smsContent: smsContent || '' });
    } catch (error) {
      console.error('Error fetching delivery SMS:', error);
    }
  };

  const getTransactionDetails = async (voucherID) => {
    setState({ fetchError: '', transactionError: '' });
    if (!showTransactions) {
      setState({
        transactionLoading: true,
        showTransactions: !showTransactions,
      });
      try {
        const [response, transferredData] = await Promise.all([
          getTransactions(props.auth.auth.token, voucherID),
          getTransferredData(props.auth.auth.token, voucherID),
        ]);

        setState({
          transactionDetails: response,
          transferredData: transferredData,
        });
        setState({ transactionLoading: false });
      } catch (error) {
        setState({
          transactionError: 'Oops, something went wrong, Please try again.',
          transactionLoading: false,
        });
      }
    } else {
      setState({ transactionDetails: [], showTransactions: !showTransactions });
    }
  };

  const getVoucherDetails = async (currentPage) => {
    setState({
      loading: true,
      voucherData: [],
      fetchError: '',
    });
    try {
      const response = await getVouchersByStatus(
        props.auth.auth.token,
        statusKey !== queryParams.filter ? statusKey : queryParams.filter,
        currentPage || (queryParams.page ? queryParams.page - 1 : 0),
        pageSize
      );
      setState({
        voucherData: response.list,
        totalPages: response.totalPageCount,
        currentPage: response.pageNo,
      });
      if (queryParams.selected) {
        const rowData = response.list.find(
          (data) => data.id === queryParams.selected
        );
        if (rowData) {
          setQueryParam({ [APP_PARAMS.SELECTED]: rowData.id });
          setState({
            showVoucherDrawer: true,
            drawerData: rowData,
            voucherId: rowData.id,
            voucherExpiryDate: rowData.expiryDate,
          });
        } else {
          setQueryParam({ [APP_PARAMS.SELECTED]: null });
        }
      }
    } catch (error) {
      setState({
        fetchError: 'Oops, something went wrong. Please try again',
      });
    }
    setState({ loading: false });
  };

  const printCarrier = async (to, from, body) => {
    setState({ isBoardPrinting: true });
    try {
      const request = createCarrierPrintRequest(checkedRows, to, from, body);
      const token = props.auth.auth.token;
      const rawPdfResponse = await getCarrierPdf(request, token);
      generateAndSavePdf(rawPdfResponse, 'Carrier_Board');
    } catch (error) {
      console.error('Error printing carrier:', error);
    } finally {
      setState({ isBoardPrinting: false });
    }
  };

  const handleTabOnClick = (key) => {
    setQueryParam({
      [APP_PARAMS.SEARCH_ID]: null,
      [APP_PARAMS.SEARCH_KEY]: null,
      [APP_PARAMS.PAGE]: 1,
    });
    setState({
      statusKey: key,
      searchKey: '',
      isClearable: false,
      checkedRows: [],
      labelsToPrint: [],
      selectAll: false,
    });
  };

  const handleShowActivationModal = () => {
    setState({ showActivationModal: true, showVoucherDrawer: false });
  };

  const handleShowMerchantCodes = () => {
    setState({ showMerchantCodesModal: true, showVoucherDrawer: false });
  };

  const handleActivationSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const isValidDetails = validateDetails(receiverMobile, receiverName);

    if (!isValidDetails) {
      setState({ validated: true });
    } else {
      setState({ activationLoading: true });
      try {
        const request = {
          voucherId: voucherId,
          name: receiverName,
          mobileNo: receiverMobile,
        };
        const token = props.auth.auth.token;
        const response = await activateVoucher(request, token);
        if (response && response.status === 'COMPLETE') {
          setState({
            ...INITIAL_ACTIVATION_STATUS,
            activationSuccess: true,
          });
          getVoucherDetails(currentPage);
        }
      } catch (error) {
        setState({
          ...INITIAL_ACTIVATION_STATUS,
          activationError: 'Oops! Something went wrong. Please try again',
        });
      }
    }
  };

  const copyRedemptionId = (text, field) => {
    copyToClipboardWithFeedback(text, field, setState);
  };

  const handleMobileChange = (receiverMobile) => {
    if (validated) {
      setState({ receiverMobile });
      validateMobileNumber(receiverMobile);
    } else {
      setState({ receiverMobile });
    }
  };

  const hideActivationModal = () => {
    setState({
      ...INITIAL_ACTIVATION_STATUS,
      showActivationModal: false,
      voucherId: '',
      mobileError: '',
      receiverName: '',
      receiverMobile: '',
    });
  };

  const toggleExtensionModal = () => {
    setState({
      showExtensionModal: !showExtensionModal,
      showVoucherDrawer: false,
    });
  };

  const handleShowUploadModal = () => {
    setState({ showUploadModal: !showUploadModal });
  };

  const handleShowPrintOptionsModal = () => {
    setState({ showPrintOptionsModal: !showPrintOptionsModal });
  };

  const handleShowOwnerTransferModal = () => {
    setState({ showOwnerTransferModal: !showOwnerTransferModal });
  };

  const handleMerchantModalClose = () => {
    setState({
      showMerchantCodesModal: !showMerchantCodesModal,
      showVoucherDrawer: false,
      selectedTransaction: null,
    });
  };

  const handleSearchDropDownOnClick = (key, label, placeholder) => {
    setQueryParam({
      [APP_PARAMS.SEARCH_KEY]: null,
      [APP_PARAMS.SEARCH_ID]: null,
    });
    getVoucherDetails(0);
    setState({
      label: label,
      searchPlaceholder: placeholder,
      searchId: key,
      searchKey: '',
      isClearable: false,
      selectAll: false,
    });
  };

  const handleCheckBoxToggle = (rowId, event) => {
    event.stopPropagation();
    handleCheck(rowId);
  };

  const handleReceiverNumberSearchUnselection = (voucherIdToRemove = null) => {
    const targetVoucherId = voucherIdToRemove || drawerData?.id;

    if (isSearchingByReceiverNumber(queryParams, searchId) && targetVoucherId) {
      setQueryParam({ [APP_PARAMS.SELECTED]: null });
      const updatedCheckedRows = checkedRows.filter(
        (id) => id !== targetVoucherId
      );
      const updatedLabelsToPrint = labelsToPrint.filter(
        (label) => label.id !== targetVoucherId
      );

      return {
        showVoucherDrawer: false,
        checkedRows: updatedCheckedRows,
        labelsToPrint: updatedLabelsToPrint,
        selectAll: false,
        drawerData: voucherIdToRemove ? null : drawerData,
        voucherId: voucherIdToRemove ? null : voucherId,
      };
    }

    return null;
  };

  const fetchUpdatedDataAfterOwnershipTransfer = async () => {
    const unselectionState = handleReceiverNumberSearchUnselection();

    if (unselectionState) {
      setState({
        ...unselectionState,
        drawerData: null,
        voucherId: null,
      });

      if (searchKey || queryParams.searchKey) {
        searchVoucherById(currentPage, true);
      } else {
        getVoucherDetails(currentPage);
      }
    } else {
      if (searchKey || queryParams.searchKey) {
        searchVoucherById(0);
      } else {
        getVoucherDetails(0);
      }
    }
  };

  const handleOnClick = (id) => {
    const rowData = voucherData.find((data) => data.id === id);
    const isCurrentlyChecked = checkedRows.includes(id);

    if (isCurrentlyChecked) {
      setQueryParam({ [APP_PARAMS.SELECTED]: rowData.id });
      setState((prev) => ({
        ...prev,
        showVoucherDrawer: true,
        drawerData: rowData,
        voucherId: id,
        voucherExpiryDate: rowData.expiryDate,
      }));
    }
  };

  const handleCheck = (rowId) => {
    setState((prev) => {
      const checkedSet = new Set(prev.checkedRows);
      let labels = [...prev.labelsToPrint];

      if (checkedSet.has(rowId)) {
        checkedSet.delete(rowId);
        labels = labels.filter((lbl) => lbl.id !== rowId);
      } else {
        checkedSet.add(rowId);
        const data = voucherData.find((v) => v.id === rowId);
        if (data) {
          labels.push({
            id: data.id,
            ownerName: data.ownerName,
            sender: data.sender,
            amount: data.amount,
            purchaseId: data.purchaseId,
            invoiceNumber: data.corporateInvoiceId,
          });
        }
      }

      return {
        ...prev,
        checkedRows: Array.from(checkedSet),
        labelsToPrint: labels,
      };
    });
  };

  const handleMultipleCheck = (ids) => {
    setState((prev) => {
      const checkedSet = new Set(prev.checkedRows);
      let labels = [...prev.labelsToPrint];

      ids.forEach((id) => {
        if (checkedSet.has(id)) {
          checkedSet.delete(id);
          labels = labels.filter((lbl) => lbl.id !== id);
        } else {
          checkedSet.add(id);
          const data = voucherData.find((v) => v.id === id);
          if (data) {
            labels.push({
              id: data.id,
              ownerName: data.ownerName,
              sender: data.sender,
              amount: data.amount,
              purchaseId: data.purchaseId,
              invoiceNumber: data.corporateInvoiceId,
            });
          }
        }
      });

      return {
        ...prev,
        checkedRows: Array.from(checkedSet),
        labelsToPrint: labels,
      };
    });
  };

  const handleSelectAll = (event) => {
    setState({ selectAll: event.target.checked });
    if (event.target.checked) {
      const selectedAll = voucherData.map((data) => data.id);
      const newLabels = voucherData.map(
        ({ id, ownerName, amount, sender, purchaseId, corporateInvoiceId }) => ({
          id,
          ownerName,
          amount,
          sender,
          purchaseId,
          invoiceNumber: corporateInvoiceId,
        })
      );
      setState({
        checkedRows: [...new Set([...checkedRows, ...selectedAll])],
        labelsToPrint: dedupeLabels([...labelsToPrint, ...newLabels]),
      });
    } else {
      const updatedCheckedRows = checkedRows.filter(
        (id) => !voucherData.some((data) => data.id === id)
      );
      const updatedLabelsToPrint = labelsToPrint.filter(
        (label) => !voucherData.some((data) => data.id === label.id)
      );
      setState({
        checkedRows: updatedCheckedRows,
        labelsToPrint: updatedLabelsToPrint,
      });
    }
  };

  const searchOnChange = (event) => {
    setQueryParam({ [APP_PARAMS.SEARCH_KEY]: null, [APP_PARAMS.PAGE]: 1 });
    setState({
      label: queryParams.searchId
        ? tabItems.searchDropDown.find(
          (item) => item.key === queryParams.searchId
        ).label
        : label,
      searchPlaceholder: queryParams.searchId
        ? tabItems.searchDropDown.find(
          (item) => item.key === queryParams.searchId
        ).placeholder
        : searchPlaceholder,
    });
    const { searchId } = state;
    const inputValue = event.target.value;
    switch (searchId) {
      case 'mobile_no':
        /^\+?[0-9]*$/.test(inputValue) &&
          setState({
            searchKey: event.target.value,
            isClearable: false,
          });
        break;
      case 'id':
      case 'purchase':
        /^[a-zA-Z0-9]*$/.test(inputValue) &&
          setState({
            searchKey: event.target.value,
            isClearable: false,
          });
        break;
      case 'corporate_invoice_id':
        /^[a-zA-Z0-9_]*$/.test(inputValue) &&
          setState({
            searchKey: event.target.value,
            isClearable: false,
          });
        break;
      case 'receiver_name':
      case 'sender_name':
        let str = inputValue.replace(/^\s+/, '');
        setState({
          searchKey: str,
          isClearable: false,
        });
        break;
      case 'created_date':
      case 'expiry_date':
        let formattedDate = inputValue.replace(/[^0-9]/g, '');
        if (formattedDate.length > 8) {
          formattedDate = formattedDate.substring(0, 8);
        }
        if (formattedDate.length > 6) {
          formattedDate = formattedDate.replace(
            /^([0-9]{4})([0-9]{2})/,
            '$1-$2-'
          );
        } else if (formattedDate.length > 4) {
          formattedDate = formattedDate.replace(/^([0-9]{4})/, '$1-');
        }
        setState({
          searchKey: formattedDate,
          isClearable: false,
        });
        break;
      default:
        setState({
          searchKey: event.target.value,
          isClearable: false,
        });
    }
  };

  const searchVoucherById = async (page, skipDrawerReopen = false) => {
    setState({
      loading: true,
      fetchError: '',
      statusKey: 'ALL',
    });
    try {
      const request = {
        searchKey: searchKey || queryParams.searchKey,
        searchId: queryParams.searchId || searchId,
        page: queryParams.page ? queryParams.page - 1 : page,
        pageSize: pageSize,
        sortBy: 'created_date',
        order: 'desc',
      };
      const token = props.auth.auth.token;
      const response = await searchVouchers(request, token);
      setState({
        voucherData: response.list,
        totalPages: response.totalPageCount,
        currentPage: response.pageNo,
      });
      if (queryParams.selected && !skipDrawerReopen) {
        const rowData = response.list.find(
          (data) => data.id === queryParams.selected
        );
        if (rowData) {
          setQueryParam({ [APP_PARAMS.SELECTED]: rowData.id });
          setState({
            showVoucherDrawer: true,
            drawerData: rowData,
            voucherId: rowData.id,
            voucherExpiryDate: rowData.expiryDate,
          });
        } else {
          // The previously selected voucher isn't in this result set
          // (filter/search/page changed) - drop the stale query param
          // instead of crashing on undefined.
          setQueryParam({ [APP_PARAMS.SELECTED]: null });
        }
      }
    } catch (error) {
      setState({
        fetchError: 'Oops, something went wrong. Please try again',
      });
    }
    setState({ loading: false });
  };

  const handleRenotifyClose = () => {
    setState({ showRenotifyModal: false });
  };

  const handleStatusChange = async (status) => {
    setState({ statusUpdateLoading: true });
    try {
      const response = await updateVoucherDetails(
        voucherId,
        { status: status },
        props.auth.auth.token
      );
      if (response) {
        toast.success('Voucher status updated successfully');
        if (searchKey || queryParams.searchKey) {
          searchVoucherById(currentPage);
        } else {
          getVoucherDetails(currentPage);
        }
        setState({
          showVoucherDrawer: false,
          statusUpdateLoading: false,
        });
      }
    } catch (error) {
      toast.error('Failed to update voucher status');
      setState({ statusUpdateLoading: false });
    }
  };

  const hasPendingActivationVouchers = () => {
    return checkedRows.some((id) => {
      const voucher = voucherData.find((data) => data.id === id);
      return voucher && voucher.status === 'PENDING_ACTIVATION';
    });
  };

  const handleMultipleStatusChange = async (status, selectedRows) => {
    if (status === 'ACTIVE' && hasPendingActivationVouchers()) {
      toast.error('Cannot change PENDING ACTIVATION vouchers to ACTIVE. Please activate them individually.');
      return;
    }

    setState({ statusUpdateLoading: true });
    try {

      await updateMultipleVoucherStatus(
        {
          voucherIds: selectedRows,
          status: status
        },
        props.auth.auth.token
      );

      toast.success('Voucher statuses updated successfully');
      if (searchKey || queryParams.searchKey) {
        searchVoucherById(currentPage);
      } else {
        getVoucherDetails(currentPage);
      }
      setState({
        checkedRows: [],
        labelsToPrint: [],
        selectAll: false,
        statusUpdateLoading: false,
      });
    } catch (error) {
      toast.error('Failed to update voucher statuses');
      setState({ statusUpdateLoading: false });
    }
  }

  const validateEditField = (field, value) => {
    return validateEditFieldValue(field, value);
  };

  const handleEditField = (field) => {
    const initialValue = getEditFieldInitialValue(field, drawerData);
    const stateKey = getEditStateKeyForField(field);

    setState({
      ...INITIAL_EDIT_STATUS,
      isEditing: true,
      editingField: field,
      [stateKey]: initialValue,
    });
  };

  const handleCancelEdit = () => {
    setState(INITIAL_EDIT_STATUS);
  };

  // The shared invoice editor calls the update endpoint itself; patch the
  // drawer and every listed voucher whose purchase the backend updated.
  const handleInvoiceUpdated = (newValue, response) => {
    const updatedPurchaseIds = response.updatedPurchaseIds || [];

    setState((prev) => ({
      ...prev,
      drawerData: prev.drawerData && {
        ...prev.drawerData,
        corporateInvoiceId: newValue,
      },
      voucherData: prev.voucherData.map((voucher) =>
        updatedPurchaseIds.includes(voucher.purchaseId)
          ? { ...voucher, corporateInvoiceId: newValue }
          : voucher
      ),
    }));
  };

  const handleSaveEdit = async () => {
    const field = state.editingField;
    let payload = {
      senderName: null,
      receiverName: null,
      message: null,
    };

    let validation;
    switch (field) {
      case 'sender':
        validation = validateSenderName(state.editSenderName);
        if (validation.isValid)
          payload.senderName = state.editSenderName.trim();
        break;
      case 'receiver':
        validation = validateReceiverName(state.editReceiverName);
        if (validation.isValid)
          payload.receiverName = state.editReceiverName.trim();
        break;
      case 'mobile':
        validation = validateMobileNumber(state.editReceiverMobile);
        if (validation.isValid)
          payload.receiverMobileNo = state.editReceiverMobile;
        break;
      case 'message':
        validation = validateMessage(state.editMessage);
        if (validation.isValid) {
          payload.message = state.editMessage.trim();
        }
        break;
      default:
        validation = { isValid: false, error: 'Invalid field type' };
    }

    if (!validation.isValid) {
      toast.error(validation.error);
      return;
    }

    try {
      setState({ detailsUpdateLoading: true });

      const response = await updateVoucherDetails(
        drawerData.id,
        payload,
        props.auth.auth.token
      );

      if (response.message === 'Voucher updated successfully') {
        toast.success('Updated successfully');

        const updatedDrawerData = {
          ...drawerData,
          sender: payload.senderName ?? drawerData.sender,
          message: payload.message ?? drawerData.message,
          ownerName: payload.receiverName ?? drawerData.ownerName,
          ownerMobile: payload.receiverMobileNo ?? drawerData.ownerMobile,
        };

        const isUpdatingMobileNumber = field === 'mobile';
        const unselectionState = handleReceiverNumberSearchUnselection();
        const shouldCloseDrawerAndUnselect =
          unselectionState && isUpdatingMobileNumber;

        if (shouldCloseDrawerAndUnselect) {
          setState({
            isEditing: false,
            editingField: null,
            editSenderName: '',
            editReceiverName: '',
            editReceiverMobile: '',
            editMessage: '',
            detailsUpdateLoading: false,
            drawerData: updatedDrawerData,
            ...unselectionState,
          });

          if (searchKey || queryParams.searchKey) {
            searchVoucherById(currentPage, true);
          } else {
            getVoucherDetails(currentPage);
          }
        } else {
          setState({
            isEditing: false,
            editingField: null,
            editSenderName: '',
            editReceiverName: '',
            editMessage: '',
            editReceiverMobile: '',
            detailsUpdateLoading: false,
            drawerData: updatedDrawerData,
          });

          if (searchKey || queryParams.searchKey) {
            searchVoucherById(currentPage);
          } else {
            getVoucherDetails(currentPage);
          }
        }
      }
    } catch (error) {
      toast.error('Failed to update');
      setState({
        detailsUpdateLoading: false
      });
    }
  };

  const handleChangeVoucherTheme = async (selectedTheme) => {
    setState({
      voucherThemeUpdateLoading: true
    });

    try {
      const response = await updateVoucherDetails(
        drawerData.id,
        { voucherThemeId: selectedTheme.id },
        props.auth.auth.token
      );

      if (response.message === 'Voucher updated successfully') {
        toast.success('Voucher theme updated successfully');
        setState({
          showVoucherThemeModal: false,
          selectedVoucherId: null,
          currentVoucherTheme: null,
          voucherThemeUpdateLoading: false,
          drawerData: {
            ...drawerData,
            imageFront: selectedTheme.imageFront,
            voucherTheme: selectedTheme,
          }
        });

        if (searchKey || queryParams.searchKey) {
          searchVoucherById(currentPage);
        } else {
          getVoucherDetails(currentPage);
        }
      } else {
        toast.error('Failed to update voucher theme');
        setState({
          voucherThemeUpdateLoading: false
        });
      }
    } catch (error) {
      toast.error('Failed to update voucher theme');
      setState({
        voucherThemeUpdateLoading: false
      });
    }
  };

  const handleCloseMerchantGroupModal = () => {
    setState({
      ...INITIAL_MERCHANT_GROUP_STATUS
    });
  };

  const handleChangeMerchantGroup = async (merchantGroup) => {
    setState({
      merchantGroupUpdateLoading: true
    });

    try {
      const response = await updateVoucherDetails(
        drawerData.id,
        { merchantGroupId: merchantGroup.id },
        props.auth.auth.token
      );

      if (response.message === 'Voucher updated successfully') {
        toast.success('Merchant Group updated successfully');
        setState({
          ...INITIAL_MERCHANT_GROUP_STATUS,
          merchantGroupUpdateLoading: false,
          drawerData: {
            ...drawerData,
            merchantGroup,
          }
        });

        if (searchKey || queryParams.searchKey) {
          searchVoucherById(currentPage);
        } else {
          getVoucherDetails(currentPage);
        }
      } else {
        toast.error('Failed to update Merchant Group');
        setState({
          merchantGroupUpdateLoading: false
        });
      }
    } catch (error) {
      toast.error('Failed to update Merchant Group');
      setState({
        merchantGroupUpdateLoading: false
      });
    }
  }

  // Search with the selected field; re-runs even when a search is already applied.
  const handleSelectSearch = () => {
    if (!searchKey) return;
    setQueryParam({
      [APP_PARAMS.SEARCH_ID]: searchId,
      [APP_PARAMS.SEARCH_KEY]: searchKey,
      [APP_PARAMS.FILTER]: null,
    });
    setState({
      isClearable: true,
      selectAll: false,
    });
    searchVoucherById(0);
  };

  // Clearing the search resets every filter (search and status). The load
  // effect watches statusKey/searchKey, so it reloads the full list once the
  // cleared state is applied.
  const handleSelectSearchClear = () => {
    setQueryParam({
      [APP_PARAMS.SELECTED]: null,
      [APP_PARAMS.SEARCH_ID]: null,
      [APP_PARAMS.SEARCH_KEY]: null,
      [APP_PARAMS.FILTER]: 'ALL',
      [APP_PARAMS.PAGE]: 1,
    });
    setState({
      searchKey: '',
      statusKey: 'ALL',
      isClearable: false,
      notFoundMessage: null,
      showVoucherDrawer: false,
      drawerData: null,
      checkedRows: [],
      labelsToPrint: [],
      selectAll: false,
    });
  };

  const renderMultipleSearch = () => {
    return (
      <SelectSearch
        options={tabItems.searchDropDown}
        selectedKey={searchId}
        onSelectChange={(key, optionLabel) => {
          const option = tabItems.searchDropDown.find((item) => item.key === key);
          handleSearchDropDownOnClick(key, optionLabel, option && option.placeholder);
        }}
        value={searchKey}
        onChange={(value) => searchOnChange({ target: { value } })}
        onSearch={handleSelectSearch}
        onClear={handleSelectSearchClear}
        placeholder={searchPlaceholder}
        maxLength={50}
      />
    );
  };

  const renderFilterByStatus = () => {
    const { statusKey, tabItems } = state;
    return (
      <Breadcrumb>
        {tabItems.status.map((item) => {
          const { key, label } = item;
          return (
            <Breadcrumb.Item
              key={key}
              active={key === statusKey}
              onClick={() => handleTabOnClick(key)}
            >
              {label}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    );
  };

  const handleVoucherPagination = (page) => {
    setQueryParam({ [APP_PARAMS.PAGE]: page + 1 });
    if (searchKey) {
      searchVoucherById(page);
    } else {
      getVoucherDetails(page);
    }
    setState({
      currentPage: page,
    });
  };

  const handleShowRenotify = () => {
    setState({ showRenotifyModal: true, showVoucherDrawer: false });
  };

  const handleDrawerOnHide = () => {
    setQueryParam({ [APP_PARAMS.SELECTED]: null });
    setState({
      showVoucherDrawer: !showVoucherDrawer,
      transactionDetails: [],
      showTransactions: false,
      selectedTransaction: null,
      ...INITIAL_EDIT_STATUS,
    });
  };

  const handleReceiverChange = ({ target: { value } }) => {
    if (/^([a-zA-Z][a-zA-Z]*(\s[a-zA-Z]*)?)?$/.test(value)) {
      setState({
        receiverName: value,
      });
    }
  };

  const renderTransactionDetails = (data) => {
    const handleClose = () => {
      setState({
        showTransactions: true,
        selectedTransaction: null,
      });
    };

    const transaction = data;
    const transactionContent = [
      { label: 'Transaction Type', value: transaction.transactionType },
      { label: 'Description', value: transaction.description },
      { label: 'Amount', value: transaction.amount.toFixed(2) },
      {
        label: 'Running Balance',
        value: transaction.runningBalance.toFixed(2),
      },
      {
        label: 'Timestamp',
        value: formatDateTime(
          transaction.timestamp,
          DATE_TIME_TYPES.DATE_TIME_12H
        ),
      },
      { label: 'Redemption ID', value: transaction.redemptionId },
      { label: 'Merchant', value: transaction.merchant },
      { label: 'Sub-Merchant', value: transaction.subMerchant },
      { label: 'Reference Code', value: transaction.referenceCode },
      { label: 'Status', value: transaction.status },
    ];

    const filteredTransactionSectionContent = transactionContent.filter(
      (item) =>
        item.value !== null && item.value !== undefined && item.value !== ''
    );

    return (
      <div className={`details_group ${styles.content}`}>
        <Card>
          <Card.Body>
            <div className={styles.header}>
              <button className={styles.closeButton} onClick={handleClose}>
                &times;
              </button>
            </div>
            {filteredTransactionSectionContent.map((item, index) => (
              <div
                key={index}
                className='detail_group_content'
                style={{ height: '1rem' }}
              >
                <span className='content_header'>{item.label}</span>
                <span
                  className='content_value'
                  style={item.style && item.style}
                >
                  {item.value ? item.value : 'N/A'}
                </span>
              </div>
            ))}
          </Card.Body>
        </Card>
      </div>
    );
  };

  const renderTransferredDetails = (data) => {
    if (!data) return null;

    const handleClose = () => {
      setState({
        showTransactions: true,
        selectedTransferred: null,
      });
    };

    const transferredContent = [
      { label: 'Transferred Id', value: data.id },
      { label: 'Date', value: moment(data.purchase.createdDate).format('DD/MM/YYYY hh:mm A') },
      { label: 'Sender Mobile No', value: data.senderMobileNo },
      { label: 'Receiver Mobile No', value: data.smsMobileNo },
      { label: 'Amount', value: data.amount.toFixed(2) },
      { label: 'Status', value: data.status },
      { label: 'Admin', value: data.admin ? data.admin.email : 'N/A' },
      { label: 'Admin Role', value: data.admin ? data.admin.role : 'N/A' }
    ]

    return (
      <div className={`details_group ${styles.content}`}>
        <Card>
          <Card.Body>
            <div className={styles.header}>
              <button className={styles.closeButton} onClick={handleClose}>
                &times;
              </button>
            </div>
            {transferredContent.map((item, index) => (
              <div
                key={index}
                className='detail_group_content'
                style={{ height: '1rem' }}
              >
                <span className='content_header'>{item.label}</span>
                <span
                  className='content_value'
                  style={item.style && item.style}
                >
                  {item.value ? item.value : 'N/A'}
                </span>
              </div>
            ))}
          </Card.Body>
        </Card>
      </div>
    );
  };

  const renderDrawer = () => {
    const handleRowClick = (redemptionId) => {
      const transaction = transactionDetails.find(
        (t) => t.redemptionId === redemptionId
      );

      setState({
        selectedTransaction: transaction,
        selectedRedemptionId: redemptionId,
      });
    };

    const handleTransferredRowClick = (id) => {
      const transferred = transferredData.find(
        (t) => t.id === id
      );

      setState({
        selectedTransferred: transferred,
      });
    };

    const data = drawerData;
    const voucherID = data.id;
    const checkBalanceUrl = buildCheckBalanceUrl(voucherID);

    const renderCopyDropdownRow = (title, displayValue, copyValue, field) => {
      const isCopyable = Boolean(copyValue);
      const { truncated, text } = truncateText(displayValue, 18);
      return (
        <div className={styles.copy_dropdown_item}>
          <span className={styles.copy_dropdown_label}>{title}</span>
          <span className={styles.copy_dropdown_value} title={displayValue || 'N/A'}>
            {text || 'N/A'}{truncated ? '...' : ''}
          </span>
          <OverlayTrigger
            placement={'top'}
            overlay={
              <Tooltip>
                {copiedField === field
                  ? `Copied ✅`
                  : isCopyable
                    ? `Click to copy ${title.toLowerCase()}`
                    : 'Nothing to copy'}
              </Tooltip>
            }
          >
            <span>
              <Button
                onClick={() => isCopyable && copyRedemptionId(copyValue, field)}
                variant='outline-primary'
                size='sm'
                disabled={!isCopyable}
                className={styles.copy_icon}
              >
                <FontAwesomeIcon icon={faCopy} />
              </Button>
            </span>
          </OverlayTrigger>
        </div>
      );
    };

    const primaryContent = [
      {
        label: 'Voucher Theme',
        value: (
          <div className={styles.voucherThemeContainer}>
            <div className={styles.imageWrapper}>
              {state.voucherThemeUpdateLoading && (
                <div className={styles.themeUpdateOverlay}>
                  <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: '24px' }} />
                </div>
              )}
              <img
                className={styles.voucherThemeImage}
                src={data.imageFront}
                alt='Voucher theme'
              />
              <Button
                variant='link'
                size='sm'
                className={styles.imageEditButton}
                disabled={state.voucherThemeUpdateLoading}
                onClick={(e) => {
                  e.stopPropagation();
                  setState({
                    showVoucherThemeModal: true,
                    selectedVoucherId: data.id,
                    currentVoucherTheme: {
                      name: data.theme || 'Unknown Theme Name',
                      imageFront: data.imageFront,
                    }
                  });
                }}
              >
                <FontAwesomeIcon icon={state.voucherThemeUpdateLoading ? faSpinner : faPen} spin={state.voucherThemeUpdateLoading} />
              </Button>
            </div>
          </div>
        ),
      },
      {
        label: 'Date Created',
        value: formatDateTimeSriLanka(data.createdDate, 'DD/MM/YYYY hh:mm A'),
      },
      {
        label: 'Amount(LKR)',
        value: data.amount
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      },
      {
        label: 'Status',
        value: (
          <Dropdown>
            <Dropdown.Toggle
              variant={(data.status === 'EXPIRED' || data.deleteDate) ? 'danger' : 'primary'}
              disabled={statusUpdateLoading || data.deleteDate}
            >
              {statusUpdateLoading ? (
                <span>
                  <FontAwesomeIcon icon={faSpinner} spin /> Updating...
                </span>
              ) :
                data.deleteDate ? (
                  tabItems.status
                    .find((item) => item.key === 'DELETED')
                    ?.label.trim().toUpperCase() || 'DELETED'
                ) : ((
                  tabItems.status
                    .find((item) => item.key === data.status)
                    ?.label.trim() || data.status
                ).toUpperCase())}
            </Dropdown.Toggle>

            {/* Status change options; the current status is highlighted
                (same as the Deliveries & Pickups filters) and not clickable */}
            <Dropdown.Menu>
              {tabItems.status
                .filter((item) => item.key !== 'ALL')
                .map((item) => {
                  const isCurrent = item.key === data.status.toUpperCase();
                  return (
                    <Dropdown.Item
                      key={item.key}
                      active={isCurrent}
                      onClick={() => !isCurrent && handleStatusChange(item.key)}
                      disabled={statusUpdateLoading || data.deleteDate}
                    >
                      {item.label.trim().toUpperCase()}
                    </Dropdown.Item>
                  );
                })}
            </Dropdown.Menu>
          </Dropdown>
        ),
      },
      { label: 'Delivery email', value: state.deliveryEmail },
      { label: 'Scheduled Date', value: formatDateTime(state.scheduledDate, 'DD/MM/YYYY hh:mm A') },
      {
        label: 'Merchant Group',
        value: data.merchantGroup ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {
              data.merchantGroup.id.length > 15 ? (
                <>{data.merchantGroup.id.substring(0, 15)}...
                  <OverlayTrigger
                    placement='top'
                    overlay={<Tooltip>{data.merchantGroup.id}</Tooltip>}
                  >
                    <Button variant='link' size='sm' className={styles.info_icon}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </Button>

                  </OverlayTrigger>
                </>) : (
                data.merchantGroup.id
              )
            }
            <Button
              variant='link'
              size='sm'
              className={styles.edit_icon}
              disabled={state.merchantGroupUpdateLoading}
              onClick={(e) => {
                e.stopPropagation();
                setState({
                  showMerchantGroupModal: true,
                  selectedVoucherId: data.id,
                  currentMerchantGroup: data.merchantGroup
                });
              }}
            >
              <FontAwesomeIcon icon={state.merchantGroupUpdateLoading ? faSpinner : faEdit} spin={state.merchantGroupUpdateLoading} />
            </Button>
          </div>
        ) : 'N/A',
      },
      {
        label: 'Message',
        value: data.message ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {data.message.length > 15 ? (
              <>
                {data.message.substring(0, 15)}...
                <OverlayTrigger
                  placement='top'
                  overlay={<Tooltip>{data.message}</Tooltip>}
                >
                  <Button variant='link' size='sm' className={styles.info_icon}>
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </Button>
                </OverlayTrigger>
              </>
            ) : (
              data.message
            )}
          </div>
        ) : (
          'N/A'
        ),
      },
      { label: 'Receiver Mobile No.', value: data.ownerMobile },
      {
        label: 'Receiver Name',
        value: data.ownerName ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {data.ownerName.length > 20 ? (
              <>
                {data.ownerName.substring(0, 20)}...
                <OverlayTrigger
                  placement='top'
                  overlay={<Tooltip>{data.ownerName}</Tooltip>}
                >
                  <Button variant='link' size='sm' className={styles.info_icon}>
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </Button>
                </OverlayTrigger>
              </>
            ) : (
              data.ownerName
            )}
          </div>
        ) : (
          'N/A'
        ),
      },
      {
        label: 'Sender Name',
        value: data.sender ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {data.sender.length > 20 ? (
              <>
                {data.sender.substring(0, 20)}...
                <OverlayTrigger
                  placement='top'
                  overlay={<Tooltip>{data.sender}</Tooltip>}
                >
                  <Button variant='link' size='sm' className={styles.info_icon}>
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </Button>
                </OverlayTrigger>
              </>
            ) : (
              data.sender
            )}
          </div>
        ) : (
          'N/A'
        ),
      },
      {
        conditionalRender: true,
        label: 'Expiry Date',
        value: formatDateTimeSriLanka(data.expiryDate, 'DD/MM/YYYY hh:mm A'),
      },
      {
        label: 'Corporate Invoice ID',
        value: (
          <CorporateInvoiceIdEditor
            value={data.corporateInvoiceId}
            purchaseId={data.purchaseId}
            isPendingVoucher={false}
            token={props.auth.auth.token}
            isEditing={isEditing && editingField === 'corporateInvoiceId'}
            onEditStart={() =>
              setState({
                ...INITIAL_EDIT_STATUS,
                isEditing: true,
                editingField: 'corporateInvoiceId',
              })
            }
            onEditEnd={handleCancelEdit}
            onUpdated={handleInvoiceUpdated}
          />
        ),
      },
    ];

    return (
      <div className='purchase_drawer_root'>
        <div className='drawer_child'>
          <div className='header_group'>
            <Dropdown>
              <Dropdown.Toggle variant='primary' id='copy-dropdown'>
                Copy
              </Dropdown.Toggle>
              <Dropdown.Menu className={styles.copy_dropdown_menu}>
                <Dropdown.ItemText>
                  {renderCopyDropdownRow('ID', voucherID, voucherID, 'id')}
                </Dropdown.ItemText>
                <Dropdown.ItemText>
                  {renderCopyDropdownRow('Link', checkBalanceUrl, checkBalanceUrl, 'url')}
                </Dropdown.ItemText>
                <Dropdown.ItemText>
                  {renderCopyDropdownRow('SMS Msg', smsContent, smsContent, 'message')}
                </Dropdown.ItemText>
              </Dropdown.Menu>
            </Dropdown>
            <Button variant='primary' onClick={handleShowRenotify}>
              Re-Notify
            </Button>
          </div>

          {selectedTransaction ? (
            renderTransactionDetails(selectedTransaction)
          ) : selectedTransferred ? (
            renderTransferredDetails(selectedTransferred)
          ) : (
            <>
              {showTransactions ? (
                <>
                  <div className={`details_group ${styles.content}`}>
                    <p>Transaction Details</p>
                    <DataTable
                      tableData={transactionDetails}
                      tableheading={transactionHeading}
                      handleOnClick={handleRowClick}
                      tag='transactionDetails'
                      fetchError={transactionError}
                      search_filter_loading={transactionLoading}
                    />
                  </div>
                  <div className={`details_group ${styles.content}`}>
                    <p>Transferred Details</p>
                    <DataTable
                      tableData={transferredData}
                      tableheading={transferredHeading}
                      handleOnClick={handleTransferredRowClick}
                      tag='transferred Details'
                      fetchError={transactionError}
                      search_filter_loading={transactionLoading}
                    />
                  </div>
                </>
              ) : (
                renderVoucherDetails(primaryContent)
              )}
            </>
          )}

          <div className='footer' style={{ padding: '0 15px' }}>
            <div
              className='button-container'
              style={{ display: 'flex', gap: '10px' }}
            >
              {data.status === 'PENDING_ACTIVATION' && (
                <Button
                  style={{ flex: 1 }}
                  onClick={() => handleShowActivationModal()}
                >
                  Activate Voucher
                </Button>
              )}

              {selectedTransaction && (
                <Button
                  style={{ flex: selectedTransaction ? '1' : 'auto' }}
                  onClick={() => handleShowMerchantCodes()}
                >
                  View Merchant Codes
                </Button>
              )}

              <Button
                className='footer'
                style={{
                  flex: selectedTransaction || data.status === 'PENDING_ACTIVATION' ? '1' : 'auto',
                  minWidth: data.status !== 'PENDING_ACTIVATION' && !selectedTransaction ? 'auto' : undefined
                }}
                onClick={() => {
                  if (showTransactions) {
                    setState({
                      showTransactions: false,
                      selectedTransaction: null,
                      selectedTransferred: null,
                    });
                  } else {
                    getTransactionDetails(voucherID);
                  }
                }}
              >
                {showTransactions ? 'Go Back' : 'View Transaction'}
              </Button>

              {!data.deleteDate && data.status.toUpperCase() === 'ACTIVE' ? (
                <Button
                  onClick={() => handleShowOwnerTransferModal()}
                  style={{ flex: selectedTransaction ? '1' : 'auto' }}
                >
                  Transfer Ownership
                </Button>
              ) : !data.deleteDate ? (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>Ownership transfer is allowed only for active vouchers</Tooltip>
                  }
                >
                  <span>
                    <Button
                      onClick={() => handleShowOwnerTransferModal()}
                      disabled={true}
                      style={{ flex: selectedTransaction ? '1' : 'auto' }}
                    >
                      Transfer Ownership
                    </Button>
                  </span>
                </OverlayTrigger>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderVoucherDetails = (data) => {
    const renderEditControls = (field) => {
      if (isEditing && editingField === field) {
        return (
          <div
            style={{ display: 'inline-flex', gap: '5px', marginLeft: '8px' }}
          >
            <Button
              variant='link'
              size='sm'
              onClick={handleSaveEdit}
              disabled={detailsUpdateLoading}
              className={styles.edit__icon}
            >
              <FontAwesomeIcon
                icon={detailsUpdateLoading ? faSpinner : faCheck}
                spin={detailsUpdateLoading}
              />
            </Button>
            <Button variant='link' size='sm' onClick={handleCancelEdit}>
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </div>
        );
      }

      return (
        <Button
          variant='link'
          size='sm'
          onClick={() => handleEditField(field)}
          style={{ marginLeft: '8px' }}
        >
          <FontAwesomeIcon icon={faEdit} />
        </Button>
      );
    };

    const renderEditableValue = (field, value) => {
      if (isEditing && editingField === field) {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Form.Group style={{ margin: 0, flex: 1 }}>
              <Form.Control
                type='text'
                value={
                  field === 'sender'
                    ? editSenderName
                    : field === 'message'
                      ? editMessage
                      : field === 'receiver'
                        ? editReceiverName
                        : editReceiverMobile
                }
                onChange={(e) => {
                  const newValue = e.target.value;
                  const validation = validateEditField(field, newValue);
                  setState({
                    [field === 'sender'
                      ? 'editSenderName'
                      : field === 'message'
                        ? 'editMessage'
                        : field === 'receiver'
                          ? 'editReceiverName'
                          : 'editReceiverMobile']: newValue,
                    editValidationError: validation.error,
                  });
                }}

                placeholder={
                  field === 'sender'
                    ? 'Enter Sender Name'
                    : field === 'receiver'
                      ? 'Enter Receiver Name'
                      : field === 'message'
                        ? 'Enter Message'
                        : 'Enter Mobile Number'
                }
                style={{ maxWidth: '200px' }}
              />

            </Form.Group>
            {renderEditControls(field)}
          </div>
        );
      }

      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span>{value || 'N/A'}</span>
          {renderEditControls(field)}
        </div>
      );
    };

    return (
      <div className={`details_group ${styles.content}`}>
        <Card>
          <Card.Body>
            {data.map((item, index) => {
              let isEditable =
                item.label === 'Sender Name' ||
                item.label === 'Receiver Name' ||
                item.label === 'Message' ||
                item.label === 'Receiver Mobile No.';
              let editField =
                item.label === 'Sender Name'
                  ? 'sender'
                  : item.label === 'Receiver Name'
                    ? 'receiver'
                    : item.label === 'Message'
                      ? 'message'
                      : 'mobile';

              return (
                <div key={index} className='detail_group_content' style={{ minWidth: 0, gap: '16px' }}>
                  <span className='content_header' style={{ flexShrink: 0 }}>{item.label}</span>
                  <span
                    className='content_value'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      minWidth: 0,
                      ...item.style,
                    }}
                  >
                    <div style={{ flex: 1, minWidth: 0 }}>
                      {isEditable
                        ? renderEditableValue(editField, item.value)
                        : item.value || 'N/A'}
                    </div>
                    {item.conditionalRender && (
                      <Button
                        variant='link'
                        size='sm'
                        onClick={() => toggleExtensionModal()}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </Button>
                    )}
                  </span>
                </div>
              );
            })}
          </Card.Body>
        </Card>
      </div>
    );
  };

  // Status shared by every selected voucher (highlighted in "Change Status").
  // null when nothing is selected, statuses differ, or a selected voucher is
  // on another page (its status isn't loaded).
  const selectedVouchersStatus = (() => {
    if (checkedRows.length === 0) return null;
    const statuses = checkedRows.map((id) => {
      const voucher = voucherData.find((data) => data.id === id);
      return voucher && !voucher.deleteDate ? voucher.status?.toUpperCase() : null;
    });
    return statuses.every((status) => status && status === statuses[0])
      ? statuses[0]
      : null;
  })();

  const confirmPayment = () => {
    if (checkedRows.length === 0) {
      toast.error('Please select at least one voucher to confirm payment.');
      return;
    }

    setState({ statusUpdateLoading: true });
    const purchaseIds = voucherData.filter((voucher) => checkedRows.includes(voucher.id)).map((voucher) => voucher.purchaseId);
    const request = { purchaseIds };

      confirmVoucherPayment(request, props.auth.auth.token)
      .then((response) => {
        if (response.message === 'VOUCHER_PAYMENT_CONFIRMED_SUCCESSFULLY') {
          toast.success('Payment confirmed successfully');
        }
      })
      .catch((error) => {
        toast.error('Failed to confirm payment');
      })
      .finally(() => {
        setState({ statusUpdateLoading: false });
      });
  }

  return (
    <div className={styles.root_div}>
      <div>
        <PageHeader text='Vouchers' />
        <div className={styles.filter_bar}>
          <div className={styles.filter_status}>
            <span className={styles.filter_label}>Filter by status</span>
            {renderFilterByStatus()}
          </div>
          <div className={styles.filter_search}>{renderMultipleSearch()}</div>
        </div>
        <div className={styles.print_button_block}>

          <div className={styles.print_button_block}>
            <InputGroup className={`${styles.input_group} mb-3`}>
              <Button
                variant='primary'
                onClick={() => confirmPayment()}
              >
                Confirm Payment
              </Button>
              <Button
                variant='primary'
                onClick={() => handleShowUploadModal()}
              >
                Codes by CSV
              </Button>
              { //hidden as per request
                1 != 1 && <Dropdown>
                  <Dropdown.Toggle
                    disabled={checkedRows.length === 0}
                    variant='success'
                    id='dropdown-basic'
                  >
                    Print Board
                    {isBoardPrinting && <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => printCarrier(true, true, true)}>
                      With Sender & Receiver
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => printCarrier(false, true, true)}
                    >
                      With Sender Only
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => printCarrier(true, false, true)}
                    >
                      With Receiver Only
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => printCarrier(false, false, true)}
                    >
                      Message Only
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>}

              <Button
                variant='primary'
                onClick={() => handleShowPrintOptionsModal()}
                disabled={checkedRows.length === 0}
              >
                Print
              </Button>

              <Button
                variant='primary'
                onClick={() => setState({ showPrinterSettingsModal: true })}
              >
                Printer Settings
              </Button>

              <Dropdown>
                <Dropdown.Toggle
                  disabled={checkedRows.length === 0}
                  variant='primary'
                  id='dropdown-basic'
                >
                  {statusUpdateLoading ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin /> {' '}
                      Updating...

                    </>
                  ) : (
                    'Change Status'
                  )}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {getAllowedStatuses(tabItems.status, ALLOWED_STATUS_KEYS).map((item) => (
                    <Dropdown.Item
                      key={item.key}
                      active={item.key === selectedVouchersStatus}
                      onClick={() => handleMultipleStatusChange(item.key, checkedRows)}
                    >
                      {item.label.trim()}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </InputGroup>
          </div>

          <div className='mb-3 d-flex align-items-end'>
            {checkedRows.length > 0 && (
              <>
                <span style={{ lineHeight: '24px' }}>
                  {checkedRows.length} voucher
                  {checkedRows.length > 1 ? 's' : ''} selected
                </span>
                <span>
                  <CloseButton
                    className='ml-2'
                    onClick={() => {
                      setState({ checkedRows: [], labelsToPrint: [] });
                    }}
                  />
                </span>
              </>
            )}
          </div>
        </div>

        <div className={`${styles.voucher_table} table-fit`}>
          <CheckableDataTable
            tableData={voucherData}
            tableheading={tableHeading}
            isSelected={isSelected}
            tag='voucher-details'
            fetchError={fetchError}
            notFoundMessage={fetchError}
            search_filter_loading={loading}
            searchFilterLoading={false}
            handleOnClick={handleOnClick}
            handleCheck={handleCheckBoxToggle}
            handleSelectAll={handleSelectAll}
            handleMultipleCheck={handleMultipleCheck}
            checkedRows={checkedRows}
            selectAll={selectAll}
          />
          {!loading && !fetchError && (
            <Pagination
              pageCount={totalPages}
              onChange={handleVoucherPagination}
              currentPage={currentPage}
            />
          )}
        </div>
      </div>
      <Drawer show={showVoucherDrawer} onHide={handleDrawerOnHide}>
        {drawerData && renderDrawer()}
      </Drawer>
      <VoucherActivationModal
        showModal={true}
        handleSubmit={handleActivationSubmit}
        showActivationModal={showActivationModal}
        loading={activationLoading}
        mobileError={mobileError}
        validated={validated}
        activationError={activationError}
        handleClose={hideActivationModal}
        receiverName={receiverName}
        receiverMobile={receiverMobile}
        handleReceiverChange={handleReceiverChange}
        handleMobileChange={handleMobileChange}
        voucherId={voucherId}
        activationSuccess={activationSuccess}
      />
      <VoucherExtensionModal
        showActivationModal={showExtensionModal}
        handleClose={toggleExtensionModal}
        voucherId={voucherId}
        token={props.auth.auth.token}
        voucherExpiryDate={voucherExpiryDate}
        searchId={searchId}
        getVoucherDetails={getVoucherDetails}
        searchVoucherById={searchVoucherById}
      />
      <ViewMerchantViewModal
        showMerchantCodesModal={showMerchantCodesModal}
        handleModalClose={handleMerchantModalClose}
        token={props.auth.auth.token}
        redemptionId={selectedRedemptionId}
        handlemodalclose={handleMerchantModalClose}
      />
      <VoucherCSVUploadModal
        token={props.auth.auth.token}
        show={showUploadModal}
        handleClose={handleShowUploadModal}
      />
      {voucherId && (
        <VoucherRenotifyModal
          show={showRenotifyModal}
          handleClose={handleRenotifyClose}
          voucherId={voucherId}
          token={props.auth.auth.token}
          setParentState={setState}
        />
      )}
      <TransferOwnershipModal
        show={showOwnerTransferModal}
        handleClose={handleShowOwnerTransferModal}
        token={props.auth.auth.token}
        voucherId={voucherId}
        updatedData={fetchUpdatedDataAfterOwnershipTransfer}
        drawerHide={handleDrawerOnHide}
      />
      <PrintOptionsModal
        show={showPrintOptionsModal}
        voucherIds={checkedRows}
        labelsToPrint={labelsToPrint}
        token={props.auth.auth.token}
        handleClose={handleShowPrintOptionsModal}
      />
      <PrinterSettingsModal
        show={showPrinterSettingsModal}
        onHide={() => setState({ showPrinterSettingsModal: false })}
        tasks={[
          PRINTER_TASKS.voucherQr,
          PRINTER_TASKS.voucherEnvelope,
          PRINTER_TASKS.voucherPackage,
        ]}
        token={props.auth.auth.token}
      />
      <ChangeMerchantGroupModal
        show={state.showMerchantGroupModal}
        handleClose={handleCloseMerchantGroupModal}
        token={props.auth.auth.token}
        currentGroup={state.currentMerchantGroup}
        onGroupSelect={handleChangeMerchantGroup}
      />
      <ChangeVoucherThemeModal
        show={state.showVoucherThemeModal}
        handleClose={() => setState({
          showVoucherThemeModal: false,
          selectedVoucherId: null,
          currentVoucherTheme: null
        })}
        token={props.auth.auth.token}
        currentTheme={state.currentVoucherTheme}
        onThemeSelect={handleChangeVoucherTheme}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

ViewVouchers.propTypes = {
  auth: PropTypes.shape({
    auth: PropTypes.shape({
      token: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default connect(mapStateToProps)(ViewVouchers);